import enviro from 'enviro';
const CUSTOM_VENDOR_CONNECTION_APP_IDS = {
  QA: 50661287,
  PROD: 58997772
};
export const CUSTOM_VENDOR_CONNECTION_APP_ID = enviro.isQa() ? CUSTOM_VENDOR_CONNECTION_APP_IDS.QA : CUSTOM_VENDOR_CONNECTION_APP_IDS.PROD;

/**
 * The callback URL the customer must allow-list on their OAuth app in the
 * provider's developer portal. Resolves to the QA host in QA so an OAuth app
 * registered for testing redirects back to the QA redirect service.
 */
export const OAUTH_REDIRECT_URL = enviro.isQa() ? 'https://oauth-redirect.hubspotqa.com/callback' : 'https://oauth-redirect.hubspot.com/callback';